export interface StudentHomeworkListDto {
    Filter: string[];
    FilterDate: string | null;
    Page?: number;
}

export const HomeworkStatuses = [
    'None',
    'Open',
    'New'
] as const;
export type HomeworkStatus = typeof HomeworkStatuses[number];

export const HomeworLabels: { readonly [K in HomeworkStatus]: string } = {
  None: 'None',
  Open: 'Open',
  New: 'New' 
};
